<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{ search }} -->
        <!-- {{ item }} -->

        <b-card class="border-none py-0 mb-0 px-1 cms_content">
            <div class="availtable datatable">
                <b-card class="w-100pct">
                    <b-card-body class="p-0">
                        <b-tabs class="gridtabs">
                            <b-tab active>
                                <template #title>
                                    <i :class="options.icon" class="text-primary mr-1"></i>
                                    {{ options.title }} - editing container '
                                    <!-- {{ this.$route.query.container }} -->
                                    <!-- <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span> -->
                                </template>
                                <form class="py-3 px-0">
                                    <b-row v-if="container">
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Container" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="container.name" :debounce="options.debounce"
                                                        placeholder="Container" size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="true"
                                                            @click="container.name = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Element" label-size="sm">
                                                <treeselect instanceId="element" v-model="element" :clearable="false"
                                                    :options="element_options" :disabled="false">
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>
                                    <b-row class="mt-2">
                                        <b-col cols="12" sm="6" md="9">
                                            <!-- <ckeditor :editor="editor" v-model="item.data" :config="editorConfig"></ckeditor> -->
                                            <wysiwyg v-model="item.data" :options="{
                                                hideModules: {
                                                    code: false,
                                                },
                                            }" />
                                            <!-- hideModules: {
                        bold: true,
                        italic: true,
                        underline: true,
                        justifyLeft: true,
                        justifyCenter: true,
                        justifyRight: true,
                        headings: true,
                        link: true,
                        code: true,
                        orderedList: true,
                        unorderedList: true,
                        image: true,
                        table: true,
                        removeFormat: true,
                        separator: false,
                      }, -->
                                        </b-col>
                                    </b-row>
                                </form>
                            </b-tab>

                            <b-tab>
                                <template #title alt="Attributes">
                                    <i class="fa fa-tags text-primary mr-1"></i> Attributes
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Type" label-for="type" label-cols="12" label-size="sm">
                                                <b-input-group>
                                                    <treeselect instanceId="type" v-model="item.type" :clearable="true"
                                                        :options="type_options" :disabled="readonly"></treeselect>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Category" label-for="category" label-cols="12"
                                                label-size="sm">
                                                <b-input-group>
                                                    <treeselect instanceId="category" v-model="item.category"
                                                        :clearable="true" :options="category_options" :disabled="readonly">
                                                    </treeselect>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Sort" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input type="number" v-model="item.sort"
                                                        :debounce="options.debounce" placeholder="Sort" size="sm"
                                                        :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                            @click="item.sort = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="State" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.state" :debounce="options.debounce"
                                                        placeholder="State" size="sm" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                            @click="item.state = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Style" label-for="style" label-cols="12">
                                                <b-form-textarea id="style" v-model="item.style" :disabled="readonly"
                                                    placeholder="Style" rows="2" class="smalltextarea"></b-form-textarea>
                                            </b-form-group> </b-col></b-row>
                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title alt="Text">
                                    <i class="fa fa-list text-primary mr-1"></i> Text
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Text" label-for="text" label-cols="12">
                                                <b-form-textarea id="data" v-model="item.data" placeholder="Text" rows="12"
                                                    class="smalltextarea courier">
                                                </b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-file-code-o text-primary mr-1"></i> HTML
                                </template>
                                <p class="py-0 px-0">
                                    <b-card-body>
                                        <b-overlay :show="busy" rounded="sm">
                                            <div id="paper" class="mb-3 p-4 background-white text-secondary">

                                                <b-row align-h="end">
                                                    <b-col cols="auto ssh-pre mr-4">
                                                        <span>Updated: </span>
                                                        <span>{{ $moment
                                                            .unix(item.updated_at / 1000)
                                                            .utc(false)
                                                            .format('DD/MM/YYYY HH:mm:ss') }}</span>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <ssh-pre v-if="data" language="xml" :label="item.label"
                                                        class="large mt-6">{{
                                                            data }}</ssh-pre>
                                                </b-row>
                                            </div>
                                        </b-overlay>
                                    </b-card-body>
                                </p>
                            </b-tab>
                            <!-- v-if="idselected" -->
                            <b-tab>
                                <template #title>
                                    <i class="fa fa-history text-primary mr-1"></i> Audit
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.created_at" button-only
                                                            label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                                                        placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.updated_at" button-only
                                                            label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                                                        placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Approved At" label-for="approved_at" label-cols="12"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.approved_at" button-only
                                                            label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.approved_at" type="text"
                                                        placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.approved_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Approved By" label-for="approved_by" label-cols="12"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.approved_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.approved_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="ID" label-for="id" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                                                        :disabled="true"></b-form-input>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>

                                </p>
                            </b-tab>
                        </b-tabs>

                    </b-card-body>
                </b-card>
            </div>

            <b-card-body>

            </b-card-body>
            <b-card-footer class="nopadding mt-2">
                <b-row no-gutters>
                    <b-col cols="auto" class="text-left mr-4">
                        <b-button squared size="sm" variant="primary" @click="publishit()" v-if="!readonly">
                            <i class="fa fa-check"></i>
                            Publish It
                        </b-button>
                    </b-col>
                    <b-col class="text-leftml-2 mt-1">
                        <div v-if="busy">
                            <i class="fa fa-spinner fa-spin text-primary"></i>
                        </div>
                        <div v-else>
                            <span v-html="message"></span>
                        </div>
                    </b-col>
                    <b-col class="text-right" cols="8">
                        <b-button squared size="sm" variant="secondary" @click="$router.go(-1)">
                            <i class="fa fa-chevron-left pr-1"></i>
                            Back
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer>
        </b-card>
        <br /><br /><br />
    </b-overlay>
</template>
  
<script>

import gql from "graphql-tag";

export default {
    name: "CMSEdit",
    data() {
        return {
            busy: false,
            readonly: false,
            requirement_container: {
                // slac: "Client SL A/C",
            },
            message: "",
            container: null,
            element: null,
            element_options: [],
            type: null,
            category: null,
            category_options: [
                { id: "carbon", label: "Carbon" },
                { id: "component", label: "Component" }
            ],
            sort: null,
            state: null,
            item: null,
            type_options: [
                { id: "b-card-group", label: "Card Group" },
                { id: "b-card", label: "Card" }
            ],
            item: {},
            options: {
                title: "CMS",
                icon: "fa fa-list",
            },
        };
    },
    // async mounted() {
    //     await this.load_container(this.$route.query.container)
    // },
    async activated() {
        await this.load_container(this.$route.query.container)
    },
    watch: {
        element: {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    console.log('element changed', newVal)
                    this.item = this.container.elements.find(o => o.id == newVal)
                }
            },
        },
    },
    methods: {
        async load_container(name) {
            console.log('load_container', name)
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query container($name: String) {
                            container(name: $name) {
                                id
                                name
                                type
                                category
                                style
                                data     
                                state
                                parent_id
                                updated_at
                                updated_by
                                approved_at
                                approved_by
                                created_at
                                created_by
                                elements {
                                    id
                                    label
                                    name
                                    data
                                    type
                                    category
                                    style
                                    state
                                    sort
                                    updated_at
                                    updated_by
                                    approved_at
                                    approved_by
                                    created_at
                                    created_by
                                }    
                            }
                        }
                        `,
                    variables: { name },
                });

                this.container = response.data.container[0]
                this.element_options = []
                for (var i = 0; i < this.container.elements.length; i++) {
                    this.element_options.push({ id: this.container.elements[i].id, label: this.container.elements[i].label })
                }
                this.element = this.container.elements[0].id

            } catch (error) {
                console.log(error);
            }
        },

        async publishit() {
            // let requirement = { ...this.requirement_container };


            // let requirements = "";
            // for (var prop in requirement) {
            //     if (this.item[prop] == null) {
            //         requirements += requirement[prop] + ", ";
            //         // break;
            //     }
            // }
            // if (requirements.length > 0) {
            //     this.message =
            //         "<span class='text-danger'>" +
            //         requirements.slice(0, -1) +
            //         " required field(s). </span>";
            //     return;
            // }

            this.busy = true;

            let variables = { rows: [this.cleanit(this.item)] };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation container_save(
                            $rows: [Container_input]         
                        ) {
                            container_save(rows: $rows) {
                            id
                            name
                            type
                            category
                            style
                            data
                            state
                            sort
                            }
                        }
                     `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },

        required(e) {

            this.requirement = {
                // slac: "Client SL A/C",
            };
        },

    },
};
</script>
  
<style></style>